import { c as _c } from "react/compiler-runtime";
import { Clipboard, ClipboardCheck, WarningTriangle } from '@byway/icons';
import type { CopyStatus } from './useCopyToClipboard';
type CopyIconProps = Readonly<{
  status: CopyStatus;
}>;
export const CopyIcon = t0 => {
  const $ = _c(3);
  const {
    status
  } = t0;
  if (status === "copied") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <ClipboardCheck decorative={true} />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (status === "failed") {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <WarningTriangle decorative={true} />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Clipboard decorative={true} />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};